import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import './index.css';
import Switch from 'Components/Ant/Switch';
import UnlabeledVerticalAutoExpander from 'Components/UI/VerticalExpander/UnlabeledVerticalAutoExpander';
import { withHousehold } from 'Context/HouseholdContext';
import { makeHideable } from '../Hideable';
import { ContextIndex } from './FieldList';
import withViewContext from './withViewContext';

class Bool extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value: aVal },
      },
    } = props;

    this.state = {
      checked: props.value || aVal || false,
      isDone: false,
    };
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => this.setState({ checked: res.attributes.value }))
      .finally(() => this.setState({ isDone: true }));
  }

  componentDidUpdate() {
    const {
      props: { showWhileChecked, showWhileUnchecked },
      state: { checked },
    } = this;
    if (checked === 'true') {
      if (showWhileChecked !== null) showWhileChecked.current.show();
      if (showWhileUnchecked !== null) showWhileUnchecked.current.hide();
    } else {
      if (showWhileUnchecked !== null) showWhileUnchecked.current.show();
      if (showWhileChecked !== null) showWhileChecked.current.hide();
    }
  }

  render() {
    const {
      props: {
        name,
        uploadValue,
        householdId,
        answerKey,
        label,
        onChange,
        checkedChildren,
        uncheckedChildren,
        test,
      },
      state: { checked, isDone },
      context: index,
    } = this;

    if (!isDone) {
      return null;
    }

    return (
      <UnlabeledVerticalAutoExpander transitionSpeed={0.4}>
        <div className="questionnaire-bool-input">
          {label !== '' ? (
            <Fragment>
              <label htmlFor={name}>{label}</label>
              <br />
            </Fragment>
          ) : null}
          <div className="switch">
            <Switch
              onChange={(e) => {
                uploadValue(householdId, answerKey, {
                  attributes: {
                    value: e.toString(),
                    index,
                  },
                }).then(
                  () => {
                    this.setState({ checked: e.toString() }, () => {
                      onChange(name, e);
                    });
                  },
                );
              }}
              defaultChecked={checked === 'true'}
              name={name}
              checkedChildren="Yes"
              unCheckedChildren="No"
              test={test}
            />
          </div>
          {checked === 'true' ? checkedChildren : uncheckedChildren}
        </div>
      </UnlabeledVerticalAutoExpander>
    );
  }
}

Bool.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  householdId: PropTypes.number.isRequired,
  answerKey: PropTypes.string.isRequired,
  label: PropTypes.string,
  checkedChildren: PropTypes.node, // Make sure wrapper has key prop
  uncheckedChildren: PropTypes.node, // Make sure wrapper has key prop
  showWhileChecked: PropTypes.instanceOf(Object),
  showWhileUnchecked: PropTypes.instanceOf(Object),
  apiResponse: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  test: PropTypes.string,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

Bool.defaultProps = {
  apiResponse: { attributes: {} },
  value: '',
  label: '',
  checkedChildren: <Fragment />,
  uncheckedChildren: <Fragment />,
  showWhileChecked: null,
  showWhileUnchecked: null,
  onChange: noop,
  test: '',
};

Bool.contextType = ContextIndex;

const BoolInput = withHousehold(withQuestionnaireFuncs(withViewContext(Bool)));

export default makeHideable(BoolInput);
